<div class="excel-download" [ngClass]="{ 'excel-ar-download': current_lang === 'ar' }">
    <!--- Dropdown option -->
    <div class="table-dropdown" *ngIf="dropDownOption && (tableData?.length !== 0 && tableData)">
        <button class="btn-select-dropdown" [ngClass]="{'select-dropdown-proptype': dropDownOption.showSelectedValue}"
            [matMenuTriggerFor]="menu" [disabled]="LockReport">
            <ng-container>
                <span> {{ "reports.transactionType" | translate }}</span>
            </ng-container>
            <mat-icon>keyboard_arrow_down</mat-icon>
        </button>
        <mat-menu #menu="matMenu" [xPosition]="current_lang === 'ar' ? 'after' : 'before'" class="table-dropdown-menu">
            <div (click)="$event.stopPropagation()">
                <h5 *ngIf="dropDownOption.label">
                    {{ dropDownOption.label | translate }}
                </h5>
                <ng-container *ngFor="let option of dropDownOption.data; let i = index">
                    <mat-checkbox (change)="selectCheckboxValue($event, option.id, option.value)"
                        [checked]="selectedOptions.includes(option.id)" [disabled]="option.id == 'Actual'"
                        class="typehead-check">
                        {{ "reports." + option.value | translate }}
                    </mat-checkbox>
                </ng-container>
            </div>
        </mat-menu>
    </div>

    <!--- Down load icon -->
    <div class="download-excel-outer" *ngIf="
      tableData?.length !== 0 &&
      tableData &&
      allowExcelDownload
    ">
        <button class="download_excel" [disabled]="LockReport" *ngIf="!downloadLoading" (click)="downloadExcel()"
            matTooltip="{{ 'reports.download_excel' | translate }}" matTooltipPosition="above"><img *ngIf="!LockReport"
                src="../../../../../../assets/images/excel-icon.svg" />
            <img *ngIf="LockReport" src="../../../../../../assets/images/excel-icon-disable.svg" /></button>
        <span *ngIf="downloadLoading"><mat-spinner class="download-spinner"></mat-spinner></span>
    </div>
    <!--- Dropdown option -->
</div>

<div class="main-table normal-table">
    <table class="table" matSort (matSortChange)="onSortTable($event)">
        <thead>
            <tr>
                <ng-container *ngFor="let tableColumn of tableColumns">

                    <!-- Conditionally render <th> with or without mat-sort-header -->
                    <th *ngIf="tableColumn.isSortable; else noSort" mat-sort-header="{{ tableColumn.header }}"
                        [class.custom-bg-th]="tableColumn.border">

                        <ng-container *ngIf="tableColumn?.recordType; else otherColumn">
                            <span class="header_label record_type">
                                {{ tableColumn?.columnName | translate }}
                                <span class="">{{ tableColumn?.symbol | reportDataValueType }}</span>
                                <span class="record_type-text">({{ "reports.record_type" | translate }})</span>
                            </span>
                        </ng-container>

                        <ng-template #otherColumn>
                            <span class="header_label">
                                {{ tableColumn?.columnName | translate }}
                                <span class="text-transform-normal">{{ tableColumn?.symbol |
                                    reportDataValueType }}</span>
                            </span>
                        </ng-template>
                    </th>

                    <!-- <th> without mat-sort-header -->
                    <ng-template #noSort>
                        <th [class.custom-bg-th]="tableColumn.border">
                            <ng-container *ngIf="tableColumn?.recordType; else otherColumnNoSort">
                                <span class="header_label record_type">
                                    {{ tableColumn?.columnName | translate }}
                                    <span class="">{{ tableColumn?.symbol | reportDataValueType }}</span>
                                    <span class="record_type-text">({{ "reports.record_type" | translate }})</span>
                                </span>
                            </ng-container>

                            <ng-template #otherColumnNoSort>
                                <span class="header_label">
                                    {{ tableColumn?.columnName | translate }}
                                    <span class="text-transform-normal">{{ tableColumn?.symbol |
                                        reportDataValueType }}</span>
                                </span>
                            </ng-template>
                        </th>
                    </ng-template>

                </ng-container>
            </tr>

        </thead>
        <tbody>
            <tr *ngFor="let element of tableData; let i = index" [ngClass]="{ hideTable: !showLoader }" [style.background-color]="element['outlier'] ? '#FFE1E1' : ''">

                <!-- Residential Units Table -->
                <ng-container *ngIf="tableName == 'residentialUnits'">
                    <td>{{element?.unit_type || '-'}}</td>
                    <td>{{(element?.count | number: '1.0-1') || '-'}}</td>
                    <td>{{(element?.min_size | number: '1.0-1') || '-'}}</td>
                    <td>{{(element?.max_size | number: '1.0-1') || '-'}}</td>
                    <td>{{(element?.avg_size | number: '1.0-1') || '-'}}</td>
                </ng-container>

                <!-- Unit Transactions & Prices Table -->
                <ng-container *ngIf="tableName == 'unitTransaction'">
                    <td>{{element?.u_unit_uid || '-'}}</td>
                    <td>{{element?.u_unit_type || '-'}}</td>
                    <td>{{(element?.transaction_date | date: 'dd MMM y') || '-'}}</td>
                    <td>{{element?.transaction_type || '-'}} {{ element?.source_name ? '(' + element.source_name + ')' :
                        '' }}</td>
                    <td class="custom-conditional-bg-td">
                        <app-record-type-display [value]="element?.value" [prop_type_govt]="element?.prop_type_govt"
                            [prop_type_estater]="element?.prop_type_estater">
                        </app-record-type-display>
                    </td>

                    <td>{{(element?.transaction_area | number: '1.0-1') || '-'}}</td>
                    <td [ngClass]="{'outlier-text': element['outlier']}">
                        {{element?.transaction_rate ? (element?.transaction_rate | number: '1.0-1') : '-'}}
                        <span class="outlier"
                            *ngIf="element['outlier'] && element?.transaction_rate">{{'reports.outlier' |
                            translate}}</span>
                    </td>
                </ng-container>

                <!-- Property Transactions Table for Without Warehouse Category(All Category) -->
                <ng-container
                    *ngIf="tableName == 'propertyTransactions' && reportCategory !== propertyCategoryEnum.IndustryWorkshopWarehouse">
                    <td>{{(element?.transaction_date) || '-'}}</td>
                    <td>{{element?.transaction_type || '-'}}</td>
                    <td class="custom-conditional-bg-td" [innerHTML]="element?.value || '-'">
                    </td>
                    <td>{{(element?.transaction_area | number: '1.0-1') || '-'}}</td>
                    <td [ngClass]="{'outlier-text': element['outlier']}">
                        {{element?.property_transaction_rate ? (element?.property_transaction_rate | number: '1.0-1') : '-'}}
                        <span class="outlier"
                            *ngIf="element['outlier'] && element?.property_transaction_rate">{{'reports.outlier' |
                            translate}}</span>
                    </td>
                </ng-container>
                <!-- Property Transactions Table for Warehouse-->
                <ng-container
                    *ngIf="tableName == 'propertyTransactions' && reportCategory === propertyCategoryEnum.IndustryWorkshopWarehouse">
                    <td>{{(element?.property_name) || '-'}}</td>
                    <td>{{(element?.transaction_date) || '-'}}</td>
                    <td class="custom-conditional-bg-td" [innerHTML]="element?.value || '-'">
                    </td>
                    <td>{{(element?.transaction_area | number: '1.0-1') || '-'}}</td>
                    <td>{{element?.value_type || '-'}}</td>
                </ng-container>

                <!-- Residential Rental Income Assessment Table -->
                <ng-container *ngIf="tableName == 'incomeAssessment'">
                    <td>{{element?.unit_type || '-'}}</td>
                    <!-- <td>{{(element?.count | number: '1.0-1') || '-'}}</td>
                    <td>{{element?.area_range || '-'}}</td> -->
                    <td>{{element?.rental_price || '-'}}</td>
                     <td>{{element?.rental_rate || '-'}}</td>
                </ng-container>

                <ng-container *ngIf="tableName == 'nearbyRentals'">
                    <td>{{element?.property_grade || '-'}}</td>
                    <td>{{(element?.rental_rates) || '-'}}</td>
                    <td *ngIf="!isSaudiCheck">{{element?.occupancy || '-'}}</td>
                </ng-container>

            </tr>
            <tr *ngIf="!showLoader" style="height: auto;" class="loader-tr">
                <td style="padding: 0;" [attr.colspan]="tableColumns?.length">
                    <app-skeleton-loader [loaderSize]="5"></app-skeleton-loader>
                </td>
            </tr>
        </tbody>
    </table>
    <!--- No Record Found -->
    <div class="data_unavail" *ngIf="(tableData?.length === 0 || !tableData) && showLoader">
        <span>
            {{"reports.dataComingSoon" | translate}}
        </span>
    </div>
    <!-- Table content blur start -->
    <div class="lock-table-row" *ngIf="LockReport">
        <img src="../../../../../../assets/images/Lock.png" alt="">
    </div>
</div>
<!--- Pagination -->
<div class="pagination-wrapper pagination-showing-count"
    *ngIf="tableData?.length !== 0 && tableData && !hidePagination">
    <ng-container *ngIf="show_step_count">
        <p *ngIf="!LockReport" [class.showingrecord-margin]="dataLength > 2">
            {{ "reports.Showing" | translate }} {{ startIndex }}
            {{ "reports.to" | translate }} {{ endIndex }}
            {{ "reports.outOf" | translate }}
            {{ dataLength | internationalNumber }}
            {{ "reports.records" | translate}}
        </p>
    </ng-container>
    <p *ngIf="LockReport" class="pb-2">
        <span class="contact-sale" (click)="openContactSales()">{{'contactSales' | translate }}</span>
        {{'to_unlock' | translate }} <ng-container *ngIf="dataLength > 3"> {{(dataLength
            - 3) | internationalNumber }} {{'rows_more'| translate}}</ng-container> <ng-container
            *ngIf="dataLength <= 3">{{'more_rows'|
            translate}}</ng-container>.
    </p>

    <mat-paginator *ngIf="dataLength > 20" [disabled]="!showLoader || LockReport" class="default-pagination"
        [length]="dataLength" [pageSize]="20" [pageSizeOptions]="[5, 10, 15, 25, 100]" [showFirstLastButtons]="true"
        (page)="onPageChange($event)" [hidePageSize]="true">
    </mat-paginator>

    <!-- Pagination input -->
    <div class="go-to-page d-flex align-items-center" *ngIf="dataLength > 20">
        <input class="go-to-page-input" type="number" [(ngModel)]="goToPageNumber" (change)="onGoToPage()"
            [disabled]="totalPages === 1 || !showLoader || LockReport" />
        <span class="oftext">of</span>
        <span>{{ totalPages }}</span>
    </div>
</div>

<!--- data cleaned Text -->
<div class="dataCleaned">
    <span>
        <ng-container *ngIf="showEstaterText">{{
            "reports.dataCleaned" | translate
            }}</ng-container>
    </span>

</div>
